const resolversByOwner = new Map();

function normalizedKey(value) {
  return String(value || '').trim();
}

function ownerResolvers(ownerId, options = {}) {
  const owner = normalizedKey(ownerId);
  if (!owner) return null;
  let resolvers = resolversByOwner.get(owner);
  if (!resolvers && options.create === true) {
    resolvers = new Map();
    resolversByOwner.set(owner, resolvers);
  }
  return resolvers || null;
}

function registerResolver(ownerId, id, resolver) {
  const owner = normalizedKey(ownerId);
  const key = normalizedKey(id);
  if (!owner || !key || typeof resolver !== 'function') return false;
  const resolvers = ownerResolvers(owner, { create: true });
  if (resolvers.has(key)) return false;
  resolvers.set(key, resolver);
  return true;
}

function unregisterResolver(ownerId, id) {
  const owner = normalizedKey(ownerId);
  const key = normalizedKey(id);
  const resolvers = ownerResolvers(owner);
  if (!resolvers || !key || !resolvers.delete(key)) return false;
  if (resolvers.size === 0) resolversByOwner.delete(owner);
  return true;
}

function unregisterResolvers(ownerId) {
  return resolversByOwner.delete(normalizedKey(ownerId));
}

function frozenCopy(value) {
  const copy = structuredClone(value);
  const freeze = item => {
    if (!item || typeof item !== 'object' || Object.isFrozen(item)) return;
    Object.freeze(item);
    Object.values(item).forEach(freeze);
  };
  freeze(copy);
  return copy;
}

function resolve(ownerId, id, context = {}, item = {}) {
  const resolver = ownerResolvers(ownerId)?.get(normalizedKey(id));
  if (typeof resolver !== 'function') return undefined;
  try {
    const result = resolver(frozenCopy(context), frozenCopy(item));
    if (result && typeof result.then === 'function') {
      Promise.resolve(result).catch(() => undefined);
      return undefined;
    }
    return structuredClone(result);
  } catch (error) {
    console.error(`Konfigurierter BOM-Resolver ${normalizedKey(ownerId)}:${normalizedKey(id)} ist fehlgeschlagen.`, error);
    return undefined;
  }
}

function resolveForSource(id, context = {}, item = {}) {
  const ownerId = String(
    context.item?.sourceSystemId
      || context.sourceSystemId
      || item.sourceSystemId
      || ''
  ).trim();
  return resolve(ownerId, id, context, item);
}

function hasResolver(ownerId, id) {
  return ownerResolvers(ownerId)?.has(normalizedKey(id)) === true;
}

export {
  hasResolver,
  registerResolver,
  resolve,
  resolveForSource,
  unregisterResolver,
  unregisterResolvers
};
